var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMarqueur(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Groupe_2357",
    "data-name": "Groupe 2357",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 17.93,
    height: 20.169,
    viewBox: "0 0 17.93 20.169",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1061",
    "data-name": "Rectangle 1061",
    width: 17.93,
    height: 20.169,
    fill: "none",
    stroke: "#033e8c",
    strokeWidth: 2
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2356",
    "data-name": "Groupe 2356",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1925",
    "data-name": "Trac\\xE9 1925",
    d: "M11.946,14.943h0a2.359,2.359,0,0,1,0-3.565,2.982,2.982,0,0,1,3.929,0,2.359,2.359,0,0,1,0,3.565A2.982,2.982,0,0,1,11.946,14.943Z",
    transform: "translate(-4.946 -5.275)",
    fill: "none",
    stroke: "#033e8c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1926",
    "data-name": "Trac\\xE9 1926",
    d: "M16.133,2c4.514,0,8.024,3.461,7.847,7.321-.3,6.469-7.847,10.831-7.847,10.831",
    transform: "translate(-7.168 -0.992)",
    fill: "none",
    stroke: "#033e8c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1927",
    "data-name": "Trac\\xE9 1927",
    d: "M2.913,21.6q.148.426.33.835c2.026,4.554,7.016,7.436,7.016,7.436",
    transform: "translate(-1.294 -10.707)",
    fill: "none",
    stroke: "#033e8c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1928",
    "data-name": "Trac\\xE9 1928",
    d: "M9.854,2C5.34,2,1.83,5.461,2.007,9.321",
    transform: "translate(-0.889 -0.992)",
    fill: "none",
    stroke: "#033e8c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarqueur);
export default __webpack_public_path__ + "static/media/marqueur.838a2f47a9db64974a708e62c9fdbd7b.svg";
export { ForwardRef as ReactComponent };